import { render, staticRenderFns } from "./CatalogoProfissionalPublico.vue?vue&type=template&id=4f6674cc&scoped=true"
import script from "./CatalogoProfissionalPublico.vue?vue&type=script&lang=js"
export * from "./CatalogoProfissionalPublico.vue?vue&type=script&lang=js"
import style0 from "./CatalogoProfissionalPublico.vue?vue&type=style&index=0&id=4f6674cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6674cc",
  null
  
)

export default component.exports